import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./store";

import { Provider } from "react-redux";

function initializeWidget() {
  const widgetRoot = document.createElement("div");
  widgetRoot.id = "popup-widget-root";
  widgetRoot.style.position = "relative";
  widgetRoot.style.zIndex = 9999;
  document.body.appendChild(widgetRoot);

  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    widgetRoot
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeWidget);
} else {
  initializeWidget();
}
